"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEmailSubscriptionsLoadingError = removeEmailSubscriptionsLoadingError;
exports.fetchEmailSubscriptions = fetchEmailSubscriptions;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _EmailSubscriptionClient = _interopRequireDefault(require("lead-flows-ui/api/EmailSubscriptionClient"));

function requestEmailSubscriptions() {
  return {
    type: _ActionTypes.REQUEST_EMAIL_SUBSCRIPTIONS
  };
}

function recieveEmailSubscriptions(subs) {
  return {
    type: _ActionTypes.RECEIVE_EMAIL_SUBSCRIPTIONS,
    payload: subs
  };
}

function errorRetrievingEmailSubscriptions(error) {
  return {
    type: _ActionTypes.ERROR_RETRIEVING_EMAIL_SUBSCRIPTIONS,
    payload: error,
    error: true
  };
}

function removeEmailSubscriptionsLoadingError() {
  return {
    type: _ActionTypes.REMOVE_EMAIL_SUBSCRIPTIONS_LOADING_ERROR
  };
}

function fetchEmailSubscriptions() {
  return function (dispatch) {
    dispatch(requestEmailSubscriptions());
    return _EmailSubscriptionClient.default.fetchActiveSubscriptions().then(function (response) {
      dispatch(recieveEmailSubscriptions(response));
    }, function (error) {
      dispatch(errorRetrievingEmailSubscriptions(error));
    }).done();
  };
}